import { getNestedValue } from '@/utils/helpers';

export const renderDealCell = ({ cell, field, formatter, Wrapper }) => {
  if (cell.row?.isLoadMore || cell.row?.isLoading) return null;
  if (cell.row?.isDeal) {
    const value = cell.row[field];
    const returnValue = formatter ? formatter(value) : value;
    if (Wrapper) {
      return <Wrapper>{returnValue}</Wrapper>;
    }

    return returnValue;
  }

  // If the row is a transaction, repeat the value from the deal
  if (cell.row?.isTransaction) {
    const value = cell.row.maCompanyTransaction?.maDeal?.[field];
    const returnValue = formatter ? formatter(value) : value;
    if (Wrapper) {
      return <Wrapper>{returnValue}</Wrapper>;
    }
    return returnValue;
  }

  // otherwise return null
  return null;
};

export const renderDealDetailsCell = ({ cell, field, formatter, Wrapper }) => {
  if (cell.row?.isLoadMore || cell.row?.isLoading) return null;
  if (cell.row?.isDeal) {
    const value = getNestedValue(cell.row, field);
    const returnValue = formatter ? formatter(value) : value;
    if (Wrapper) {
      return <Wrapper>{returnValue}</Wrapper>;
    }

    return returnValue;
  }

  // If the row is a transaction, repeat the value from the deal
  if (cell.row?.isTransaction) {
    const value = getNestedValue(cell.row, `maCompanyTransaction.maDeal.${field}`);
    const returnValue = formatter ? formatter(value) : value;
    if (Wrapper) {
      return <Wrapper>{returnValue}</Wrapper>;
    }
    return returnValue;
  }

  // otherwise return null
  return null;
};

export const renderCompanyTransactionCell = ({
  cell,
  dealField,
  transactionField,
  defaultValue,
}) => {
  if (cell.row?.isLoadMore || cell.row?.isLoading) return null;
  if (cell.row?.isDeal) {
    // the default value should only apply to deal rows
    return getNestedValue(cell.row, dealField) || defaultValue;
  }

  // If the row is a transaction, return the seller company name from the asset transaction
  if (cell.row?.isTransaction) {
    return getNestedValue(cell.row, transactionField);
  }

  return null;
};

export const renderAssetTransactionCell = ({
  cell,
  transactionField,
  dealField,
  formatter,
  defaultValue,
}) => {
  if (cell.row?.isLoadMore || cell.row?.isLoading) return null;

  let value = null;
  if (cell.row?.isTransaction) {
    value = getNestedValue(cell.row, transactionField);
  }

  if (cell.row?.isDeal) {
    // the default value should only apply to deal rows
    value = getNestedValue(cell.row, dealField) || defaultValue;
  }

  if (formatter) {
    value = formatter(value);
  }

  if (Number(value) === 0) {
    // if the value is zero, return an empty string
    return '';
  }

  return value;
};
